export default {
  rates: ({ rates }) => rates,
  ratesObj: ({ ratesObj }) => ratesObj,
  nonRates: ({ nonRates }) => nonRates,
  alopRates: ({ alopRates }) => alopRates,
  nonCatLarge: ({ nonCatLarge }) => nonCatLarge,
  catRatesGroup: ({ catRatesGroup }) => catRatesGroup,
};
